<template>
  <span class="boss-main-container">
    <!-- ▼社員からの評判情報作成-->
    <real-intention-form
      v-show="!isSubmittable"
      :is-edit="isEdit"
      :real-intention.sync="realIntention"
      data-test="real-intention-form"
      @filledOut="setSubmittableAndScrollToTop(true)"
    />
    <!-- ▼社員からの評判情報確認-->
    <real-intention-confirm
      v-show="isSubmittable"
      :is-edit="isEdit"
      :real-intention="realIntention"
      data-test="real-intention-confirm"
      @back="setSubmittableAndScrollToTop(false)"
      @un-publish="registerOrUpdate(false)"
      @publish="registerOrUpdate(true)"
    />
  </span>
</template>

<script>
import RealIntentionForm from '@/components/organisms/RealIntentionForm'
import RealIntentionConfirm from '@/components/organisms/RealIntentionConfirm'
import Indicator from '@/lib/indicator'

export default {
  components: {
    RealIntentionForm,
    RealIntentionConfirm
  },
  data () {
    return {
      isSubmittable: false,
      realIntention: {
        age: '',
        gender: { id: 0, name: '' },
        serviceYear: '',
        post: '',
        career: { id: 0, name: '' },
        icon: '',
        question1: '',
        question2: '',
        question3: ''
      }
    }
  },
  computed: {
    isEdit () {
      return !!this.realIntentionId
    },
    realIntentionId () {
      return this.$route.params.realIntentionId === null ? null : Number(this.$route.params.realIntentionId)
    },
    requestParam () {
      return {
        age: this.realIntention.age,
        gender: this.realIntention.gender.id,
        serviceYear: this.realIntention.serviceYear,
        post: this.realIntention.post,
        career: this.realIntention.career.id,
        icon: this.realIntention.icon,
        question1: this.realIntention.question1,
        question2: this.realIntention.question2,
        question3: this.realIntention.question3
      }
    }
  },
  created () {
    if (this.isEdit) this.fetchRealIntention()
  },
  methods: {
    setSubmittableAndScrollToTop (isSubmittable) {
      this.$set(this, 'isSubmittable', isSubmittable)
      this.$nextTick(() => {
        // 登録・編集確認を表示する時と確認画面から戻る時、上部をフォーカスさせる
        this.$scrollTo('body', 0)
      })
    },
    fetchRealIntention () {
      this.$http.secured.get(`/real_intention/real_intentions/${this.realIntentionId}`).then(response => {
        this.$set(this, 'realIntention', response.data)
      })
    },
    registerOrUpdate (isPublish) {
      this.isEdit ? this.update(isPublish) : this.register(isPublish)
    },
    register (isPublish) {
      Indicator.emitShow()
      this.$http.secured.post('/real_intention/real_intentions', { ...this.requestParam, isPublish: isPublish })
        .then(() => {
          this.$toasted.global.success({ message: '社員からの評判を登録しました。' })
          this.$router.push({ name: 'realIntentionTop' })
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    update (isPublish) {
      Indicator.emitShow()
      this.$http.secured.put(`/real_intention/real_intentions/${this.realIntentionId}`, { ...this.requestParam, isPublish: isPublish })
        .then(() => {
          this.$toasted.global.success({ message: '社員からの評判を更新しました。' })
          this.$router.push({ name: 'realIntentionTop' })
        }).finally(() => {
          Indicator.emitHide()
        })
    }
  }
}
</script>
